export default "__VITE_ASSET__BBqr722t__"